import type { AnnotationEntry } from '@geosoft/viewer-sdk';
import { buildModelTree, type ModelTreeNode } from './modelTreePlugin';

interface ModelTreePanelProps {
  readonly visibleLayerIds: ReadonlyArray<string>;
  readonly annotations: ReadonlyArray<AnnotationEntry>;
}

export function ModelTreePanel({ visibleLayerIds, annotations }: ModelTreePanelProps) {
  const tree = buildModelTree(visibleLayerIds, annotations);

  return (
    <>
      <p>Layer and annotation hierarchy for the active project.</p>
      <TreeNodeView node={tree} />
    </>
  );
}

function TreeNodeView({ node }: { readonly node: ModelTreeNode }) {
  return (
    <div className={`model-tree-node model-tree-node-${node.kind}`}>
      <span>{node.label}</span>
      {node.children && node.children.length > 0 && (
        <ul>
          {node.children.map((child) => (
            <li key={child.id}>
              <TreeNodeView node={child} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
